import { n as $, C as v, c as I, a as u } from "./article-srUBAy2r.mjs";
import { s as n } from "./styled-egLbU9Lr.mjs";
import { jsxs as m, jsx as x } from "react/jsx-runtime";
import { Box as C } from "@mui/system";
import y, { useImperativeHandle as R, useEffect as P } from "react";
import { cssToken as s } from "./utils.mjs";
import { C as B } from "./cssTokens-C6UiAxBc.mjs";
const Q = n("em", { name: $, slot: "Accent" })({
  fontStyle: "normal",
  color: v.accentColor()
}), D = n(C, { name: "Collapse", slot: "root" })({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  flex: "1 1 0"
}), G = n(C, { name: "Collapse", slot: "container" })({
  flex: "1 1 0"
}), X = ({ open: e, header: o, footer: t, children: a, ...l }) => /* @__PURE__ */ m(D, { ...l, children: [
  o,
  /* @__PURE__ */ x(G, { sx: { overflow: e ? "visible" : "hidden" }, children: a }),
  t
] }), Y = n("img")({ border: 0, display: "block", color: "transparent" }), W = n("div", { name: I, slot: "root" })({
  [`@property ${u.offset}`]: {
    syntax: '"<length>"',
    initialValue: "0px"
  },
  width: `calc(100% - ${u.offset()} - ${u.offset()})`,
  maxWidth: u.width(),
  paddingInline: u.offset(),
  marginInline: "auto",
  boxSizing: "content-box",
  containerName: "content",
  containerType: "inline-size"
});
W.displayName = I;
const E = "Details", F = n("details", { name: E })({
  "& > summary": {
    display: "flex",
    flexFlow: "row nowrap"
  },
  "& > summary::-webkit-details-marker": {
    display: "none"
  },
  "& > summary::marker": {
    display: "none"
  }
}), Z = ({ open: e = !1, children: o, summary: t, marker: a, renderMarker: l = () => null, ...i }) => {
  const [p, d] = y.useState(e);
  return /* @__PURE__ */ m(
    F,
    {
      open: p || e,
      onToggle: (f) => {
        d(f.currentTarget.open);
      },
      ...i,
      children: [
        /* @__PURE__ */ m("summary", { children: [
          t,
          /* @__PURE__ */ m("span", { className: "Details-Marker", children: [
            a,
            l(p)
          ] })
        ] }),
        o
      ]
    }
  );
}, k = (e, o) => {
  e.style.width = o.width + "px", e.style.height = o.height + "px";
}, S = (e) => e.height / e.width, T = (e, o) => {
  const t = o.width || e.width, a = t * S(e);
  return { width: t, height: a };
}, b = "VideoPlayer", _ = {
  stageColor: s(b, ["stage", "color"])
}, z = n(C, { name: b })({}), L = n("video", { name: b, slot: "Video" })({
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "cover"
}), V = y.forwardRef(({ sx: e, controlsList: o, ...t }, a) => {
  const l = y.useRef(null), i = y.useRef(null), p = (o || "").split(" ");
  return R(a, () => ({
    play() {
      return i.current ? i.current.play() : Promise.reject(new Error("Player not ready"));
    },
    pause() {
      return i.current ? Promise.resolve(i.current.pause()) : Promise.reject(new Error("Player not ready"));
    }
  })), P(() => {
    const d = () => {
      const f = l.current, g = i.current;
      !g || !f || k(g, T({ width: g.videoWidth, height: g.videoHeight }, { width: f.offsetWidth }));
    };
    return window.addEventListener("resize", d), () => window.removeEventListener("resize", d);
  }, []), /* @__PURE__ */ x(z, { ref: l, sx: e, children: /* @__PURE__ */ x(
    L,
    {
      controlsList: o,
      disableRemotePlayback: p.includes("noremoteplayback"),
      onLoadedMetadata: (d) => {
        l.current && k(
          d.currentTarget,
          T(
            {
              width: d.currentTarget.videoWidth,
              height: d.currentTarget.videoHeight
            },
            { width: l.current.offsetWidth }
          )
        );
      },
      playsInline: p.includes("nofullscreen"),
      ref: i,
      "x-webkit-airplay": p.includes("noremoteplayback") ? "deny" : "allow",
      ...t
    }
  ) });
});
V.displayName = b;
const c = "Input", r = {
  Gap: s(c, "gap"),
  ColorBackground: s(c, ["color", "bg"]),
  ColorText: s(c, ["color", "text"]),
  ColorTextPlaceholder: s(c, ["color", "text", "placeholder"]),
  ColorBorder: s(c, ["color", "border"]),
  ColorBorderFocus: s(c, ["color", "border", "focused"]),
  DimensionRadius: s(c, ["dimension", "radius"])
}, j = n("span", { name: c })({
  display: "inline-flex",
  alignItems: "center",
  gap: r.Gap(),
  paddingInlineStart: r.Gap(),
  paddingInlineEnd: r.Gap(),
  borderColor: r.ColorBorder(),
  borderRadius: r.DimensionRadius(),
  backgroundColor: r.ColorBackground(),
  color: r.ColorText(B.color.text.default()),
  borderWidth: "1px",
  borderStyle: "solid",
  lineHeight: 1,
  flexGrow: 1,
  "&:hover, &:focus-within": {
    borderColor: r.ColorBorderFocus()
  }
}), N = n("input", { name: c, slot: "Control" })({
  color: "inherit",
  backgroundColor: "transparent",
  outline: "none",
  borderWidth: 0,
  padding: 0,
  paddingBlock: r.Gap(),
  paddingInlineStart: r.Gap(),
  fontSize: "1em",
  flex: "1 1 0",
  "&::placeholder": {
    color: r.ColorTextPlaceholder(`hsl(from ${r.ColorText()} h s calc(l + 20))`)
  }
}), ee = ({ Control: e = N, controlRef: o, startAdornment: t, endAdornment: a, sx: l, ...i }) => /* @__PURE__ */ m(j, { sx: l, children: [
  t,
  /* @__PURE__ */ x(e, { ref: o, ...i }),
  a
] }), h = "Field", w = {
  LabelColor: s(h, ["color", "lbl"]),
  Gap: s(h, ["dimension", "gap"]),
  BaseWidth: s(h, ["width"])
}, oe = n(C, { name: h })({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  flexBasis: w.BaseWidth("auto"),
  gap: w.Gap()
}), te = n("label", { name: h, slot: "label" })({
  color: w.LabelColor()
}), H = Intl.NumberFormat("ru-ru"), re = ({ numberFormat: e = H, value: o, currency: t = "₽", ...a }) => /* @__PURE__ */ m("span", { ...a, children: [
  e.format(o),
  " ",
  t
] });
export {
  X as C,
  Z as D,
  oe as F,
  Y as I,
  te as L,
  re as P,
  Q as T,
  V,
  W as a,
  _ as b,
  r as c,
  ee as d,
  w as e
};
